import forOwn from 'lodash/forOwn';
import pickBy from 'lodash/pickBy';
import includes from 'lodash/includes';
import map from 'lodash/map';

const buildGeneralInformation = general => {
    const bannedKeys = ['PicturePreview'];
    const parsedGeneral = {};

    const noBannedKeys = pickBy(general, (_, key) => !includes(bannedKeys, key));

    forOwn(noBannedKeys, (value, key) => {
        if (key === 'Name') {
            parsedGeneral['Description'] = value;
        } else if (key === 'Description') {
            parsedGeneral['ExtraDescription'] = value;
        } else if (key === 'Picture') {
            parsedGeneral['Picture'] = value;
        }
    });

    return [parsedGeneral];
};

const buildExpressConfiguration = express => [{
    Role: '1',
    ExtraData: {
        Monitor: +express.Recording,
        DefaultExtension: +express.Extension,
        DefaultRings: +express.RingTime,
        RecordingCapacity: +express.RecordingCapacity,
        Moh: express.MusicOnHold,
        GroupType: +express.Strategy
    }
}];

const buildUsers = users => map(users, user => ({
    EntityType: 'user',
    Entity: user.UserId
}));

export const buildUserGroup = (general, express, users) => {
    const parsedGeneral = buildGeneralInformation(general);
    const parsedExpress = buildExpressConfiguration(express);
    const members = buildUsers(users);

    return {
        Description: parsedGeneral[0].Description,
        ExtraDescription: parsedGeneral[0].ExtraDescription,
        PictureURL: parsedGeneral[0].Picture,
        AddRoles: parsedExpress,
        Members: members
    };
};

export const buildUserGroupUpdate = (general, express, users) => {
    const parsedGeneral = buildGeneralInformation(general);
    const parsedExpress = buildExpressConfiguration(express);
    const members = buildUsers(users);

    let addOrUpdateRole = express.HasRole ? { UpdateRole: parsedExpress[0] } : { AddRoles: parsedExpress };

    return {
        Description: parsedGeneral[0].Description,
        ExtraDescription: parsedGeneral[0].ExtraDescription,
        PictureURL: parsedGeneral[0].Picture,
        Members: members,
        ...addOrUpdateRole
    };
}
